import React from "react";
import { Grid, Text } from "@chakra-ui/react";

import { Card } from "components";
import OrganizationActions from "./OrganizationActions";
import { Organization } from "types/organization";

interface Props {
  organization: Organization;
}

const OrganizationRow: React.FC<Props> = ({ organization }: Props) => {
  const { name, displayName } = organization;
  return (
    <Card>
      <Grid gap={5} templateColumns="1fr fit-content(100%)">
        <Text fontSize="2xl">{displayName ? displayName : name}</Text>
        <OrganizationActions organization={organization} />
      </Grid>
    </Card>
  );
};

export default OrganizationRow;
